import React from 'react';

const ItemForm2 = (props) => {
    return (
        <div className="item-form mt-2.5">
            <div className="item-grp flex gap-2.5 mb-2">
                <div className="input-grp w-[15%]">
                    <label>L.R. No</label>
                    <input
                        type="text"
                        id="lRNo"
                        name="lRNo"
                        className="inputFocus w-full"
                        autocomplete="off"
                        value={props.invoiceDetails.lRNo}
                        onChange={(event) =>
                            props.handleChange(event, "lRNo", "invoiceDetails")
                        }
                    />
                </div>

                <div className="input-grp w-[15%]">
                    <label>L.R. Date</label>
                    <input
                        type="date"
                        id="lRDate"
                        name="lRDate"
                        className="inputFocus w-full"
                        autocomplete="off"
                        value={props.invoiceDetails.lRDate}
                        onChange={(event) =>
                            props.handleChange(event, "lRDate", "invoiceDetails")
                        }
                    />
                </div>

                <div className="input-grp w-[10%]">
                    <label>Cases</label>
                    <input
                        type="number"
                        id="cases"
                        name="cases"
                        className="inputFocus w-full"
                        autocomplete="off"
                        value={props.invoiceDetails.cases}
                        onChange={(event) =>
                            props.handleChange(event, "cases", "invoiceDetails")
                        }
                    />
                </div>
                {props.page !== 'InvoiceRM' && props.page !== 'InvoicePM' ?
                    <div className="input-grp w-[15%]">
                        <label>E.W.B. No</label>
                        <input
                            type="text"
                            id="ewbNo"
                            name="ewbNo"
                            className="inputFocus w-full"
                            autocomplete="off"
                            value={props.invoiceDetails.ewbNo}
                            onChange={(event) =>
                                props.handleChange(event, "ewbNo", "invoiceDetails")
                            }
                        />
                    </div>
                    :
                    <div className="input-grp w-[15%]">
                        <label>Road Permit No</label>
                        <input
                            type="text"
                            id="roadPermitNo"
                            name="roadPermitNo"
                            className="inputFocus w-full"
                            autocomplete="off"
                            value={props.invoiceDetails.roadPermitNo}
                            onChange={(event) =>
                                props.handleChange(event, "roadPermitNo", "invoiceDetails")
                            }
                        />
                    </div>
                }

                <div className="input-grp w-[10%]">
                    <label>Weight (kgs)</label>
                    <input
                        type="text"
                        id="weight"
                        name="weight"
                        className=" inputFocus w-full"
                        autocomplete="off"
                        value={props.invoiceDetails.weight}
                        onChange={(event) =>
                            props.handleChange(
                                event,
                                "weight",
                                "invoiceDetails"
                            )
                        }
                    />
                </div>

                <div className="input-grp w-[12%]">
                    <label>Freight (+)</label>
                    <input
                        type="number"
                        id="freight"
                        name="freight"
                        className="inputFocus w-full"
                        autocomplete="off"
                        value={props.invoiceDetails.freight}
                        onChange={(event) =>
                            props.handleChange(event, "freight", "invoiceDetails")
                        }
                    />
                </div>

                <div className="input-grp w-[12%]">
                    <label>Other (+)</label>
                    <input
                        type="number"
                        id="other"
                        name="other"
                        className="inputFocus w-full"
                        autocomplete="off"
                        value={props.invoiceDetails.other}
                        onChange={(event) =>
                            props.handleChange(event, "other", "invoiceDetails")
                        }
                    />
                </div>

                <div className="input-grp w-[11%]">
                    <label>Round Off</label>
                    <input
                        type="number"
                        id="roundOff"
                        name="roundOff"
                        className="inputFocus w-full"
                        autocomplete="off"
                        disabled
                        value={props.invoiceDetails.roundOff}
                        onChange={(event) =>
                            props.handleChange(event, "roundOff", "invoiceDetails")
                        }
                    />
                </div>

            </div>

            <div className="item-grp flex gap-2.5 mb-3.5 w-[100%]">
                <div className="input-grp w-full">
                    <label>Invoice Narration</label>
                    <input
                        type="text"
                        id="invoiceNarration"
                        name="invoiceNarration"
                        className="inputFocus w-full"
                        autocomplete="off"
                        value={props.invoiceDetails.invoiceNarration}
                        onChange={(event) =>
                            props.handleChange(event, "invoiceNarration", "invoiceDetails")
                        }
                    />
                </div>
            </div>
            <div className="input-grp flex gap-[10px]">
                <input
                    type="checkbox"
                    id="changeShippedAdd"
                    name="changeShippedAdd"
                    className='w-[20px] h-[20px]'
                    autocomplete="off"
                    value={props.invoiceDetails.changeShippedAdd}
                    onChange={(event) =>
                        props.handleChangeCheckBox(event, "changeShippedAdd", "invoiceDetails")
                    }
                    checked={props.invoiceDetails.changeShippedAdd}
                />
                <label>Change Shipped Add. ?</label>
            </div>
            {props.invoiceDetails.changeShippedAdd === true ?
                <>
                    <div className="input-grp w-full mt-[10px]">
                        <label>Shipped to</label>
                        <textarea
                            rows="5"
                            name="addressLine1"
                            id="addressLine1"
                            autocomplete="off"
                            value={props.invoiceDetails.addressLine1}
                            onChange={(event) =>
                                props.handleChange(event, "addressLine1", "invoiceDetails")
                            }></textarea>

                        {/* <input
                            type="text"
                            id="addressLine2"
                            name="addressLine2"
                            className="inputFocus w-full mb-[10px]"
                            autocomplete="off"
                            value={props.invoiceDetails.addressLine2}
                            onChange={(event) =>
                                props.handleChange(event, "addressLine2", "invoiceDetails")
                            }
                        />
                        <input
                            type="text"
                            id="addressLine3"
                            name="addressLine3"
                            className="inputFocus w-full mb-[10px]"
                            autocomplete="off"
                            value={props.invoiceDetails.addressLine3}
                            onChange={(event) =>
                                props.handleChange(event, "addressLine3", "invoiceDetails")
                            }
                        />
                        <input
                            type="text"
                            id="addressLine4"
                            name="addressLine4"
                            className="inputFocus w-full mb-[10px]"
                            autocomplete="off"
                            value={props.invoiceDetails.addressLine4}
                            onChange={(event) =>
                                props.handleChange(event, "addressLine4", "invoiceDetails")
                            }
                        /> */}
                    </div>
                </>
                : null}
        </div>
    );
};

export default ItemForm2;